"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatName;
var isFieldArrayRegx = /\[\d+\]$/;

function formatName(context, name) {
  var sectionPrefix = context._reduxForm.sectionPrefix;

  return !sectionPrefix || isFieldArrayRegx.test(name) ? name : sectionPrefix + "." + name;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/util/prefixName.js
 ** module id = 244
 ** module chunks = 0
 **/